import EventTypeList from "./EventTypeList";

export default EventTypeList